import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"
import styled, { css } from "styled-components"
import getGatsbyImage from "utils/getGatsbyImage"
import { FONT_FAMILIES } from "../../../styles/Theme"

const Wrapper = styled.div`
  position: relative;
  min-height: 300px;
  display: flex;
  > :first-child {
    position: absolute !important;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: -1;
  }
`

const Content = styled.div<{ flipped?: boolean }>`
  max-width: 900px;
  width: 100%;
  display: flex;
  align-items: center;
  margin: 0 auto;
  padding: 20px 0;
  ${(props) =>
    props.flipped &&
    css`
      flex-direction: row-reverse;
    `}
  > * {
    flex: 1;
    width: 100%;
    height: 100%;
  }
  > :nth-child(2) {
    * {
      object-fit: contain;
    }
    img {
      object-fit: contain !important;
    }
  }
  @media (max-width: 930px) {
    flex-direction: column;
    ${(props) =>
      props.flipped &&
      css`
        flex-direction: column-reverse;
      `};
    > :first-child {
      max-width: 500px;
      padding: 0 20px;
      text-align: center;
    }
  }
`

const Explanation = styled.div`
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 1.2rem;
  line-height: 1.7rem;
  h3 {
    ${FONT_FAMILIES.libreBaskerville};
    font-size: 2rem;
    font-weight: bold;
    text-align: left;
    margin: 0;
    margin-block-start: 0;
    margin-block-end: 0;
    padding: 0;
    margin-bottom: 0px;
  }
  @media (max-width: 930px) {
    h3 {
      text-align: center;
    }
  }
`

interface IProps {
  backgroundImage: any
  image: any
  title: string
  description: string
  flipped?: boolean
}

const ExplanationHero = (props: IProps) => (
  <Wrapper>
    <GatsbyImage
      image={getGatsbyImage(
        props.backgroundImage && props.backgroundImage.localFile
      )}
      alt={`${props.title} background`}
    />
    <Content flipped={props.flipped}>
      <Explanation>
        { props.title && <h3>{props.title}</h3> }
        { props.description && <p>{props.description}</p> }
      </Explanation>
      {props.image && (
        <GatsbyImage
          image={getGatsbyImage(props.image.localFile)}
          alt={`${props.title} image`}
        />
      )}
    </Content>
  </Wrapper>
)

ExplanationHero.defaultProps = {
  flipped: false,
}

export default ExplanationHero
